import { useEffect } from "react";
import { useAccount, useDisconnect, useSignMessage } from "wagmi";

import { useAppDispatch, useAppSelector } from "store/store";
import { getProof } from "store/zkp/solana-proof/actions";

import { isErrorResult } from "services";
import { LOCAL_STORAGE_KEYS } from "configs";
import { SUPPORTED_LISK_CHAIN_ID } from "configs/web3";
import { handleWagmiError } from "utils";

import { ProofPayload } from "store/zkp/solana-proof/types";
import { checkLiskProof } from "store/zkp/lisk-proof/actions";
import { resetLiskProofState } from "store/zkp/lisk-proof";

const useHandleLiskProof = () => {
  const token = useAppSelector(state => state.auth.token);

  const { signMessage } = useSignMessage();
  const { disconnect } = useDisconnect();
  const { chainId, address } = useAccount();

  const dispatch = useAppDispatch();

  useEffect(() => {
    handleCheckLiskProof();
  }, [chainId, address]);

  const handleCheckLiskProof = async () => {
    try {
      const liskAccessToken = localStorage.getItem(LOCAL_STORAGE_KEYS.liskToken);
      const liskWallet = localStorage.getItem(LOCAL_STORAGE_KEYS.liskWallet);
      if (chainId && address && chainId === SUPPORTED_LISK_CHAIN_ID) {
        if (!liskAccessToken || !liskWallet || address !== liskWallet) {
          dispatch(getProof()).then(res => {
            if (!isErrorResult(res.payload)) {
              const { payload } = res.payload as ProofPayload;
              signMessage(
                { message: payload },
                {
                  onError: error => {
                    handleDisconnectLisk();
                    handleWagmiError(error.message);
                    console.error("error in SignMessage", error);
                  },
                  onSuccess: data => {
                    dispatch(checkLiskProof({ chainId: chainId.toString(), address, signature: data, payload })).then(
                      response => {
                        if (isErrorResult(response.payload)) {
                          handleDisconnectLisk();
                        } else {
                          localStorage.setItem(LOCAL_STORAGE_KEYS.liskWallet, address);
                        }
                      },
                    );
                  },
                },
              );
            } else {
              handleDisconnectLisk();
            }
          });
        }
      }
    } catch (e) {
      console.error("Error in handleCheckLiskProof", e);
    }
  };

  const handleDisconnectLisk = () => {
    if (chainId && token) {
      disconnect();
    }
    dispatch(resetLiskProofState());
  };
};

export default useHandleLiskProof;
